export default {
    getLanguages: state => state.languages,
    getAppLocale: state => state.app_locale
}
